module.exports = __webpack_public_path__ + "static/apple_splash_1125-468a0a721de50c1b3d5b476e4ae12cbf.png";